import Link from '@mui/material/Link';
import LoadingButton from 'atoms/LoadingButton/LoadingButton';
import NextLink from 'atoms/NextLink';
import Modal from 'molecules/Modal';
import React, { useState } from 'react';
import { IOfferingInfo } from 'utils/globalTypes';
import { safeRunRequest } from 'utils/networkRequests';

import s from '../SharedModal.module.scss';

interface AccessOfferingProps {
  offering?: IOfferingInfo;
  open: boolean;
  onClose: () => void;
}

const AccessOffering = ({ offering, open, onClose }: AccessOfferingProps) => {
  const [isLoading, setIsLoading] = useState<boolean>();

  const onRequestAccess = async () => {
    try {
      if (offering?.offering_id) {
        const body = { id: offering?.offering_id };
        return safeRunRequest('accessOffering', body);
      }
    } finally {
      onClose();
    }
  };

  const handleOnClose = () => {
    setIsLoading(false);
    onClose();
  };

  return (
    <Modal
      title={'Exclusive Offering'}
      open={open}
      onClose={() => {
        handleOnClose();
      }}
      maxWidth="sm"
    >
      <div className={s.SharedModal}>
        <div className={s.SharedModal__main}>
          <div>{'Access to this offering is restricted.'}</div>
          <div>
            {
              'Upon your request, a member of our investor relations team will reach out to you shortly and provide you with access.'
            }
          </div>
          <NextLink passHref href="https://www.usremsecurities.com/terms-of-use">
            <Link target="_blank">{'Terms of use'}</Link>
          </NextLink>

          <div className={s.SharedModal__buttons}>
            <LoadingButton
              loading={isLoading}
              disabled={!!isLoading}
              onClick={onRequestAccess}
              className={s.SharedModal__button}
            >
              {'Request access'}
            </LoadingButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AccessOffering;
